module.exports = __webpack_public_path__ + "img/refresh.a3be6645.svg";